import type { StockStatusItem } from "~/types/storyblok/storyblok";

export function useStockStatus() {
	const { stockStatus } = useAppStore();

	const getStockStatus = (
		idSeed?: string,
		inStock?: boolean
	): StockStatusItem | null => {
		const ids = idSeed?.split(",").map((id) => id.trim()) || [];

		for (const id of ids) {
			const matchingStatus = stockStatus.find((status) => status.id === id);
			if (matchingStatus) {
				return inStock && matchingStatus.fallbackInStockId
					? getStockStatus(matchingStatus.fallbackInStockId, true)
					: matchingStatus;
			}
		}

		if (inStock === true) {
			return stockStatus.find((status) => status.id === "in-stock") || null;
		} else if (inStock === false) {
			return stockStatus.find((status) => status.id === "out-of-stock") || null;
		}

		return null;
	};

	return {
		getStockStatus
	};
}
